import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import FontAwesome from 'react-fontawesome';
import checkmarkGreen from '../../images/circular-check-button.svg'
import FormFooter from '../form/FormFooter.js'


class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.handlerReset = this.handlerReset.bind(this); 
  }

  handlerReset() {
    this.props.resetDefault();
    return false;
  }

  render() {
    let colorClass = ''
    
    if(this.props.uniq) {
      colorClass = 'text--green text--center';
    } else { 
      colorClass = 'text--green text--center';
    }

    return(
      <div>
        <Row center="xs">
          <Col xs={10}>
            <div className="checkmark-green">
              <img src={checkmarkGreen} />
            </div>
          </Col>
        </Row>

        <Row center="xs">
          <Col xs={10}>
            <p className = { colorClass + ' p--message' }> Операцію виконано успішно! </p>
            <p className='text--center text--grey'>Електронну адресу <b>{ this.props.email }</b> збережено.</p>
            <p className='text--center text--grey'>У березні цього року ви отримаєте лист з інструкціями для доступу до сайту.</p>
            <p className='text--center text--grey'>Дякуємо!</p>
          </Col>
        </Row>

        <FormFooter />

      </div>
    );

  }
}


export default Notification;



// WEBPACK FOOTER //
// ./src/components/notification/index.js